import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import TopBar from "@/components/TopBar";
import BottomNav from "@/components/BottomNav";
import CategoryBadge from "@/components/CategoryBadge";
import { MapPin, Wallet, Calendar, CheckCircle2 } from "lucide-react";

export default function MerchantFeed() {
  const { t, tCat, tCity, tAct } = useLang();
  const [feed, setFeed] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/requests/feed").then(r => setFeed(r.data)).catch(e => setErr(errMsg(e)));
  }, []);

  return (
    <div className="app-shell pb-24" data-testid="merchant-feed">
      <TopBar title={t("matchedRequests")} back={false} />
      <div className="px-5 pt-4">
        {err && <div className="text-sm text-red-600 bg-red-50 rounded-lg p-3">{err}</div>}
        {feed.length === 0 && !err && <div className="card-surface p-5 text-sm text-zinc-600">{t("noFeed")}</div>}
        <div className="space-y-3">
          {feed.map((r) => (
            <Link
              key={r.id}
              to={`/merchant/request/${r.id}`}
              data-testid={`feed-card-${r.id}`}
              className="card-surface p-4 flex gap-3 items-start"
            >
              <CategoryBadge category={r.category} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <div className="font-semibold text-zinc-900 truncate">{tCat(r.category)}{r.activity ? ` · ${tAct(r.activity)}` : ""}</div>
                  {r.already_offered && <span className="pill bg-emerald-50 text-emerald-700"><CheckCircle2 className="h-3 w-3" />{t("alreadyOffered")}</span>}
                </div>
                <p className="text-sm text-zinc-600 line-clamp-2 mt-0.5">{r.description}</p>
                <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs text-zinc-500">
                  <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{tCity(r.city)}{r.district ? ` — ${r.district}` : ""}</span>
                  <span className="inline-flex items-center gap-1"><Wallet className="h-3 w-3" />{r.budget} {t("saudiRiyal")}</span>
                  <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" />{r.deadline}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
